import { t } from '@lingui/macro'

import { Tooltip } from '@mui/material'
import DoneIcon from '@mui/icons-material/Done'
import DoneAllIcon from '@mui/icons-material/DoneAll'

import { ChatMessage } from '@/core/models/chat-room.model'

export function MessageStatusIcon({ message }: { message: ChatMessage }) {
  const readersCount = message.readBy.filter((userId) => userId !== message.author).length
  const isRead = readersCount > 0

  const tooltipTitle = isRead ? t`seen by ${readersCount} person${readersCount > 1 ? 's' : ''}` : t`sent`

  return (
    <Tooltip title={tooltipTitle}>
      {isRead ? <DoneAllIcon sx={{ fontSize: 16, color: '#4fc3f7', ml: 0.5 }} /> : <DoneIcon sx={{ fontSize: 16, color: '#9e9e9e', ml: 0.5 }} />}
    </Tooltip>
  )
}
